module.exports = __webpack_public_path__ + "img/landingpage-video-simple-tablet.c3cce477.svg";